









































































import { mapGetters } from 'vuex';

export default {
    name: 'JobDetails',

    props: {
        canModifyJob: {
            default: false,
            required: false,
            type: Boolean,
        },

        completed: {
            default: null,
            required: false,
            type: [Boolean, null],
        },
    },

    computed: {
        ...mapGetters('jobs/single', {
            job: 'getSingleJob',
        }),
    },

    methods: {
        edit() {
            this.$emit('open-draft', 1);
        },
    },
};
